<div class="d-flex flex-column">
	<label class="text-center text-tertiary fw-semibold w-100">
		Estatística mensal (mm) - {{ periodoTitulo }}
	</label>

	<div
		*ngIf="carregandoRelatorio; else tabela"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false"></seira-loading>
	</div>
	<ng-template #tabela>
		<div
			style="max-width: 1300px"
			*ngIf="dadosTabelaRelatorio.length; else semDados">
			<div class="row mt-3 mb-2">
				<seira-public-pagination
					[items]="dadosTabelaRelatorio"
					[itemsPerPage]="5">
					<ng-template let-item="item">
						<div class="mb-2">
							<label
								for="tabela-precipitacao-por-posto"
								class="text-tertiary mb-2 fw-semibold">
								{{
									item.posto === item.municipio
										? item.municipio + ' - ' + item.tipo
										: item.municipio + ' - ' + item.posto + ' - ' + item.tipo
								}}
							</label>
							<seira-public-table
								#tabelaEstatisticaMensal
								id="tabela-precipitacao-por-posto"
								[hasFooter]="false"
								[hasHeader]="false"
								[info]="false"
								[paging]="false"
								[searching]="false"
								[columns]="colunas"
								[scrollX]="true"
								[data]="item.data" />
						</div>
					</ng-template>
				</seira-public-pagination>
			</div>
		</div>
	</ng-template>
	<seira-card-info aditionalClasses="my-3" [texto]="descricaoRelatorio" />
</div>
<ng-template #semDados>
	<seira-sem-dados [loading]="carregandoRelatorio" />
</ng-template>
